export const containerStyle = () => ({
  display: "flex",
});

export const textFieldAreaStyle = () => ({
  padding: "32px",
  display: "flex",
  flexDirection: "column",
  gap: 2,
  width: "50%",
});
